import Container from "react-bootstrap/Container";
import FormSection from "../components/formsection";
import Button from "react-bootstrap/Button";
import { Row, Col, Card, Accordion } from "react-bootstrap";
import "../styles/dualEducation.css";
import "../styles/sliderCalculator.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

export default function BusinessLoanConsulting() {
  const [loanAmount, setLoanAmount] = useState(50); // M Ft
  const [term, setTerm] = useState(60); // months

  // Simplified calculation for a subsidized loan (e.g. 5% interest)
  const annualRate = 0.03;
  const monthlyRate = annualRate / 12;
  const monthlyRepayment =
    (loanAmount * 1_000_000 * monthlyRate) /
    (1 - Math.pow(1 + monthlyRate, -term));

  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <span className="badge">GYORS • BANKFÜGGETLEN • KÉNYELMES</span>

        <h1 className="title">
          Vállalati hitelek <br />
          <span style={{ color: "#c7d2fe" }}>sorban állás nélkül</span>
        </h1>

        <p className="subtitle">
          Több bank ajánlatát kérjük be egyszerre, így nem kell külön
          bankfiókokat járnod. Szakértőink végigkísérnek a teljes folyamaton az
          első lépéstől a szerződéskötésig.
          <br />
          <span className="fw-bold">
            Számold ki tervezett hiteled várható törlesztőrészletét!
          </span>
        </p>

        <div className="cta">
          <Button href="#calculation" className="btn btn-primary">
            Kalkulátor
          </Button>

          <Button href="#leadform" className="btn btn-secondary">
            Ajánlatot kérek
          </Button>
        </div>
      </Container>

      <Container>
        <section className="section">
          <Row className="g-4">
            <Col md={4}>
              <Card className="card">
                <div className="kpi">24 óra</div>
                <div className="muted">Garantált előbírálati idő</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">Díjmentes</div>
                <div className="muted">Tanácsadás és ügyintézés</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">10+ Bank</div>
                <div className="muted">Versenyeztetett pénzintézetek</div>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="hitelek" className="section">
          <h2 className="h2">Milyen hitelekben segítünk?</h2>
          <p className="lead">
            Legyen szó államilag támogatott konstrukcióról vagy piaci hitelről,
            megkeressük a cégednek legkedvezőbb megoldást.
          </p>

          <Row className="g-3">
            <Col md={6}>
              <Card className="card h-100">
                <h3>Széchenyi Kártya Program</h3>
                <p className="small">
                  Államilag támogatott, rendkívül kedvező kamatozású
                  finanszírozás.
                </p>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    <strong>Folyószámlahitel:</strong> Napi likviditáskezeléshez
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    <strong>Likviditási Hitel:</strong> Forgóeszköz
                    finanszírozáshoz
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    <strong>Beruházási Hitel:</strong> Fejlesztésekhez,
                    eszközvásárláshoz
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    <strong>Széchenyi Lízing:</strong> Gép- és járműbeszerzéshez
                  </li>
                </ul>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="card h-100">
                <h3>Piaci alapú hitelek</h3>
                <p className="small">
                  Rugalmas megoldások, ha a támogatott konstrukciók nem
                  alkalmazhatóak.
                </p>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    <strong>Egyedi célok:</strong> Telephelyvásárlás,
                    kapacitásbővítés
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    <strong>Gyors folyósítás:</strong> Kevesebb kötöttség
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    <strong>Bankfüggetlenség:</strong> Versenyeztetett piaci
                    ajánlatok
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    <strong>Személyre szabott:</strong> Egyedi törlesztési
                    ütemezés
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>
        </section>

        <Container id="calculation">
          <h2 className="h2 mt-5">Hitelkalkulátor</h2>
          <section className="slider-calculator section p-0">
            <div className="calculator-wrapper">
              <h3 className="h4">
                Hitelösszeg: <span className="number">{loanAmount}</span> millió
                Ft
              </h3>
              <input
                type="range"
                min={5}
                max={500}
                step={5}
                value={loanAmount}
                onChange={(e) => setLoanAmount(Number(e.target.value))}
                className="slider"
              />

              <h3 className="h4 mt-4">
                Futamidő: <span className="number">{term}</span> hónap
              </h3>
              <input
                type="range"
                min={12}
                max={120}
                step={12}
                value={term}
                onChange={(e) => setTerm(Number(e.target.value))}
                className="slider"
              />

              <div className="revenue-block">
                <div className="row">
                  <Col md={12}>
                    <div className="revenue-text">
                      Becsült havi törlesztőrészlet*:
                    </div>
                    <div className="revenue-value">
                      <strong>
                        {Math.round(monthlyRepayment).toLocaleString()} Ft / hó
                      </strong>
                    </div>
                  </Col>
                </div>
                <div className="disclaimer mt-3">
                  *A kalkuláció 3%-os éves kamatlábbal számolt tájékoztató
                  jellegű becslés. A pontos törlesztőrészlet a választott
                  konstrukciótól és a hitelbírálat eredményétől függ.
                </div>
              </div>
            </div>
            <div className="text-center mt-5">
              <Button href="#leadform" className="btn btn-primary">
                Pontos ajánlatot kérek
              </Button>
            </div>
          </section>
        </Container>

        <section id="miert-mi" className="section">
          <h2 className="h2">Miért érdemes velünk intézni?</h2>
          <Row className="g-3">
            <Col md={4}>
              <Card className="card h-100">
                <h3>Bankfüggetlenség</h3>
                <p>
                  Nem egyetlen bank érdekeit képviseljük, hanem a Te cégednek
                  keressük meg a piacon elérhető legjobb megoldást.
                </p>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="card h-100">
                <h3>Időmegtakarítás</h3>
                <p>
                  Nem kell tucatnyi bankfiókot végigjárnod. Egyetlen
                  adatközléssel több bank ajánlatát is megkapod.
                </p>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="card h-100">
                <h3>Szakértői támogatás</h3>
                <p>
                  Segítünk az adminisztrációban és a dokumentáció
                  összeállításában, hogy a hitelbírálat zökkenőmentes legyen.
                </p>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="folyamat" className="section">
          <h2 className="h2">Hogyan zajlik a folyamat?</h2>
          <div className="steps-container mt-4">
            <Row className="g-4">
              <Col md={2} xs={12} className="text-center">
                <div className="step-number">1</div>
                <p className="fw-bold">Kapcsolat</p>
                <p className="small">Űrlap kitöltése vagy telefon</p>
              </Col>
              <Col md={2} xs={12} className="text-center">
                <div className="step-number">2</div>
                <p className="fw-bold">Előbírálat</p>
                <p className="small">24 órán belül visszajelzünk</p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">3</div>
                <p className="fw-bold">Versenyeztetés</p>
                <p className="small">Több banktól kérünk be ajánlatot</p>
              </Col>
              <Col md={2} xs={12} className="text-center">
                <div className="step-number">4</div>
                <p className="fw-bold">Döntés</p>
                <p className="small">Kiválasztjuk a legjobb hitelt</p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">5</div>
                <p className="fw-bold">Folyósítás</p>
                <p className="small">Szerződéskötés és pénz a számlán</p>
              </Col>
            </Row>
          </div>
        </section>

        <Container id="leadform">
          <h2 className="h2">Kérjen ajánlatot még ma!</h2>
          <p className="lead small">
            Tudja meg 24 órán belül, mekkora hitelre és milyen feltételekkel
            jogosult a vállalkozása!
          </p>
          <Row>
            <Col md={4}>
              <FormSection formType="Vállalati Hitel" />
            </Col>
            <Col md={7} className="ms-md-5 ps-md-5 pt-2">
              <ul className="list check-list mt-3">
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Díjmentes ügyintézés</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Előbírálat 24 órán belül</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Több bank ajánlata egy helyen</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Személyre szabott finanszírozás</h4>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Accordion flush className="faq-accordion">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                Mennyi idő alatt derül ki, hogy kaphatok-e hitelt?
              </Accordion.Header>
              <Accordion.Body>
                Az előbírálat eredménye jellemzően 24 órán belül megvan. A
                teljes hitelbírálati folyamat – a banktól és a konstrukciótól
                függően – akár 4 munkanap alatt is végbemehet.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>
                Mennyibe kerül a szolgáltatás?
              </Accordion.Header>
              <Accordion.Body>
                Az ügyfelek számára az ajánlatkérés, a bankok versenyeztetése és
                a teljes körű hitelügyintézés díjmentes.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                Kell személyesen bankba mennem?
              </Accordion.Header>
              <Accordion.Body>
                A folyamat nagy része online vagy telefonon intézhető. Személyes
                megjelenésre jellemzően csak a folyamat legvégén, a
                szerződéskötéskor van szükség.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </section>
      </Container>
    </>
  );
}
